import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CampaignCompleteTemplate } from 'components/Templates'

const CampaignComplete: FC = () => {
  return (
    <Layout headline={'キャンペーン'} iconPath={'/icon/white/cms.svg'} title={'完了 | キャンペーンの編集'}>
      <CampaignCompleteTemplate />
    </Layout>
  )
}

export default CampaignComplete
